<template>
  <div class="index-container" v-loading="loading">
    <div class="index-title">销售出货通知单</div>
    <div class="add-botton">
      <el-button size="mini" type="primary" @click="addList()">新增</el-button>
    </div>
    <template>
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column label="日期">
          <template slot-scope="scope">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="scope.row.date"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="销售助理">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.sales_name"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="客户全称">
          <template slot-scope="scope">
            <el-select filterable v-model="scope.row.agent" placeholder="请选择">
              <el-option
                v-for="item in clientList"
                :key="item.Occ18"
                :label="item.Occ18"
                :value="item.Occ18"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column label="收货地址">
          <template slot-scope="scope">
            <el-select
              @change="addressChange(scope.row, scope.$index)"
              v-model="scope.row.address"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in addressList"
                :key="item.id"
                :label="item.address"
                :value="item"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="收货人姓名">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.contact"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="收货电话">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.phone"></el-input>
          </template>
        </el-table-column>-->
        <el-table-column label="产品型号">
          <template slot-scope="scope">
            <el-select
              @change="proChange(scope.row)"
              v-model="scope.row.product"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="productSearch"
            >
              <el-option
                v-for="(item,index) in productList"
                :key="index"
                :label="item.Ima02"
                :value="item.Ima02"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="封装形式">
          <template slot-scope="scope">
            <el-select v-model="scope.row.package" placeholder="请选择">
              <el-option
                v-for="(item,index) in packageList"
                :key="index"
                :label="item.Ima021"
                :value="item.Ima021"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="出货数量">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.quantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="批号" v-if="pageType === 'inform'">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.lot"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="快递收件信息">
          <template slot-scope="scope">
            <div class="addr-list">
              地址选择：
              <el-select
                filterable
                remote
                reserve-keyword
                :remote-method="addressSearch"
                @change="addressChange(scope.$index, scope.row)"
                v-model="scope.row.address"
                placeholder="请搜索"
                clearable
              >
                <el-option
                  v-for="(item,index)  in addressList"
                  :key="index"
                  :label="item.address"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="addr-list">
              收货人姓名：
              <el-input placeholder="请输入" v-model="scope.row.contact"></el-input>
            </div>
            <div class="addr-list">
              收货人电话：
              <el-input placeholder="请输入" v-model="scope.row.phone"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="快递单号" v-if="pageType === 'inform'">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.courier_number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input placeholder="请输入" v-model="scope.row.remark"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index)">删除</el-button>
            <el-button size="mini" type="primary" @click="copy(scope.row, scope.$index)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="button-box">
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>
<script>
import api from '../api/api';
export default {
  data() {
    return {
      tableData: [
        {
          date: '',
          sales_name: '',
          agent: '',
          product: '',
          package: '',
          quantity: '',
          address: '',
          contact: '',
          phone: '',
          remark: ''
        }
      ],
      clientList: [],
      productList: [],
      packageList: [],
      detailId: '',
      addressList: [],
      editId: '',
      loading: true,
      addressInfo: '',
      pageType: ''
    };
  },
  mounted() {
    const value = this.$route.query;
    if (value.id) {
      this.detailId = value.id;
      this.pageType = value.type;
      this.getDetail();
    }
    this.getProList();
    this.getAgentList();
  },
  methods: {
    // 复制
    copy(item, index) {
      console.log(this.tableData, index);
      let obj = {
        date: item.date,
        sales_name: item.sales_name,
        agent: item.agent,
        product: '',
        package: '',
        quantity: 0,
        address: item.address,
        contact: item.contact,
        phone: item.phone,
        remark: item.remark,
        lot: item.lot,
        courier_number: item.courier_number
      };
      if (this.pageType == 'inform') {
        this.tableData[index].quantity = 0;
        obj = {
          date: item.date,
          sales_name: item.sales_name,
          agent: item.agent,
          product: item.product,
          package: item.package,
          quantity: 0,
          address: item.address,
          contact: item.contact,
          phone: item.phone,
          remark: item.remark,
          lot: item.lot,
          courier_number: item.courier_number
        };
      }
      this.tableData.splice(index + 1, 0, obj);
    },
    //   地址选择
    addressChange(index, item) {
      this.tableData[index].contact = item.address.contact;
      this.tableData[index].phone = item.address.phone;
      this.tableData[index].address = item.address.address;
    },
    // 提交
    submit() {
      if (this.tableData.length == 0) {
        this.$message.warning('至少添加一条数据！');
        return;
      }
      const arrData = this.tableData;
      let index = this.tableData.length - 1;
      if (!arrData[index].date) {
        this.$message.warning(`第${index + 1}条数据日期未填写!`);
      } else if (!arrData[index].sales_name) {
        this.$message.warning(`第${index + 1}条数据客户名称未填写!`);
      } else if (!arrData[index].sales_name) {
        this.$message.warning(`第${index + 1}条数据销售助理未填写!`);
      } else if (!arrData[index].agent) {
        this.$message.warning(`第${index + 1}条数据客户名称未填写!`);
      } else if (!arrData[index].product) {
        this.$message.warning(`第${index + 1}条数据产品型号未填写!`);
      } else if (!arrData[index].package) {
        this.$message.warning(`第${index + 1}条数据封装形式未填写!`);
      } else if (!arrData[index].quantity) {
        this.$message.warning(`第${index + 1}条数据出货数量未填写!`);
      } else {
        if (this.pageType === 'inform') {
          this.loading = true;
          const params = {
            id: parseInt(this.editId),
            notification_details: this.tableData
          };
          api.editNotification(params).then(res => {
            const result = res.data;
            if (result.code === 0) {
              this.$message.success('提交成功!');
              this.tableData = [
                {
                  date: '',
                  sales_name: '',
                  agent: '',
                  product: '',
                  package: '',
                  quantity: '',
                  address: '',
                  contact: '',
                  phone: '',
                  remark: '',
                  lot: ''
                }
              ];
              this.$router.go(-1);
            } else {
              this.$message.warning(result.msg);
            }
          });
          this.loading = false;
        } else {
          this.loading = true;
          const params = {
            id: parseInt(this.editId),
            pre_notification_details: this.tableData
          };
          console.log(params);
          debugger;
          api.editPreNotification(params).then(res => {
            const result = res.data;
            if (result.code === 0) {
              this.$message.success('提交成功!');
              this.tableData = [
                {
                  date: '',
                  sales_name: '',
                  agent: '',
                  product: '',
                  package: '',
                  quantity: '',
                  address: '',
                  contact: '',
                  phone: '',
                  remark: '',
                  lot: ''
                }
              ];
              this.$router.go(-1);
            } else {
              this.$message.warning(result.msg);
            }
          });
          this.loading = false;
        }
      }
    },
    //   新增
    addList() {
      const item = {
        date: '',
        sales_name: '',
        agent: '',
        product: '',
        package: '',
        quantity: '',
        address: '',
        contact: '',
        phone: '',
        remark: '',
        lot: ''
      };
      const arrData = this.tableData;
      let index = this.tableData.length - 1;
      if (this.tableData.length === 0) {
        this.tableData.push(item);
        return;
      }
      if (!arrData[index].date) {
        this.$message.warning(`第${index + 1}条数据日期未填写!`);
      } else if (!arrData[index].sales_name) {
        this.$message.warning(`第${index + 1}条数据客户名称未填写!`);
      } else if (!arrData[index].sales_name) {
        this.$message.warning(`第${index + 1}条数据销售助理未填写!`);
      } else if (!arrData[index].agent) {
        this.$message.warning(`第${index + 1}条数据客户名称未填写!`);
      } else if (!arrData[index].product) {
        this.$message.warning(`第${index + 1}条数据产品型号未填写!`);
      } else if (!arrData[index].package) {
        this.$message.warning(`第${index + 1}条数据封装形式未填写!`);
      } else if (!arrData[index].quantity) {
        this.$message.warning(`第${index + 1}条数据出货数量未填写!`);
      } else {
        this.tableData.push(item);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // 删除
    handleDelete(index) {
      //   if (index == 0) {
      //     this.$message.warning('至少保留一条数据！');
      //     return;
      //   }
      this.tableData.splice(index, 1);
    },
    getDetail() {
      if (this.pageType === 'inform') {
        api
          .getNotificationDetail({ notification_id: this.detailId })
          .then(res => {
            const result = res.data;
            if (result.code === 0) {
              this.tableData = result.data.details.notification_details
                ? result.data.details.notification_details
                : [];
              if (this.tableData.length <= 0) {
                this.secondGet();
              }
              this.editId = result.data.details.id;
              this.loading = false;
            } else {
              this.$message.warning(result.msg);
            }
          });
      } else {
        api.getPreNoticeDetail({ notification_id: this.detailId }).then(res => {
          const result = res.data;
          if (result.code === 0) {
            this.tableData = result.data.details.details
              ? result.data.details.details
              : [];
            this.editId = result.data.details.id;
            this.loading = false;
          } else {
            this.$message.warning(result.msg);
          }
        });
      }
    },
    secondGet() {
      api.getPreNoticeDetail({ notification_id: this.detailId }).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.tableData = result.data.details.details
            ? result.data.details.details
            : [];
          this.editId = result.data.details.id;
          this.loading = false;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    // 产品选择
    proChange(item) {
      item.package = '';
      this.getPackageList(item.product);
    },
    // 地址搜索
    addressSearch(query) {
      this.getAddress(query);
    },
    // 客户搜索
    agentSearch(query) {
      this.getAgentList(query);
    },
    // 查新代理商地址
    getAddress(val) {
      const params = {
        key_word: val ? val : ''
      };
      api.keywordsgetList(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.addressList = result.data.address;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    // 查询代理商列表
    getAgentList(val) {
      const params = {
        key_word: val ? val : ''
      };
      api.getAgent().then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.clientList = result.data.occ;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    // 产品搜索
    productSearch(query) {
      this.getProList(query);
    },
    // 查询产品列表
    getProList(key_word) {
      const params = {
        key_word: key_word ? key_word : ''
      };
      api.getProList(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.productList = result.data.product_model;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    // 查询封装数据
    getPackageList(value) {
      api.getPackageList({ product_name: value }).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.packageList = result.data.product_model;
        } else {
          this.$message.warning(result.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  position: relative;
  flex: 1;
  padding: 32px;
  overflow: auto;
  .index-title {
    padding: 20px 0;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
  .button-box {
    padding: 80px 0 0;
    text-align: center;
  }
  .add-botton {
    padding: 30px 0;
    text-align: right;
  }
  .addr-list {
    margin-bottom: 16px;
  }
}
/deep/ {
  .el-date-editor {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/orderDetail.vue